import { createStore, applyMiddleware } from 'redux'
import promise from 'redux-promise'
import thunk from 'redux-thunk'
import reducers from 'reducers'

let middleware = applyMiddleware(promise, thunk)

if (process.env.NODE_ENV !== 'production') {
  const { createLogger } = require('redux-logger')
  const logger = createLogger({ collapsed: true, diff: true })
  middleware = applyMiddleware(promise, thunk, logger)
}

const store = createStore(reducers, middleware)

export default store
